const isProduction = (): boolean =>
  typeof process.env.REACT_APP_PRODUCTION_ENV === 'string' &&
  process.env.REACT_APP_PRODUCTION_ENV === 'true';

export default isProduction;
